module.exports = __webpack_public_path__ + "static/img/lightkey_logo.dd9490e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lightkey_logo.png
// module id = 9j5Q
// module chunks = 1